export type SnMenuItemHideExpression<D> = (data?: D | undefined) => boolean;
